export const GET_BILLING_STATUS = 'GET_BILLING_STATUS';
export const SET_BILLING_STATUS = 'SET_BILLING_STATUS';
export const GET_BILLS_HISTORY = 'GET_BILLS_HISTORY';
export const SET_BILLS_HISTORY = 'SET_BILLS_HISTORY';
export const DOWNLOAD_BILL = 'DOWNLOAD_BILL';


